import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/AddOutlined";
import { contactTableHeaders } from "../../pages/setup/components/managementcompanies/config/mgmtContactConfig";

const ContactTableHeader = ({ isEditMode, onAddNew }) => {
  return (
    <tr className="sticky top-0 z-10">
      {isEditMode && (
        <Tooltip
          title="Create a new Contact in the database."
          enterDelay={1000}
        >
          <th className="px-2 py-1 hover:bg-gray-200">
            <button
              onClick={onAddNew}
              className="text-sss-blue-sel hover:text-sss-info"
            >
              <AddIcon />
            </button>
          </th>
        </Tooltip>
      )}
      {contactTableHeaders.map((header, index) => (
        <Tooltip key={index} title={header.title} enterDelay={1000}>
          <th className="px-2 py-1 text-left font-medium text-sss-blue-sel whitespace-nowrap overflow-ellipsis min-w-[100px]">
            {header.label}
          </th>
        </Tooltip>
      ))}
    </tr>
  );
};

ContactTableHeader.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  onAddNew: PropTypes.func.isRequired,
};

export default ContactTableHeader;
